import { CalendarCheck, Coins, PlaneTakeoff } from "lucide-react";
import { daysUntil, formatCalendarDate, money } from "../lib/format";
import type { TripProfile } from "../types";

/**
 * The trip terms set by the Aventuria team: departure, final payment, and the contribution that
 * locks the quoted rate — with how far the customer's savings already go towards it.
 */
export function TripMilestones({ trip, saved, compact = false }: { trip: TripProfile; saved: number; compact?: boolean }) {
  const contribution = trip.rateLockContribution;
  const covered = contribution ? Math.min(1, saved / contribution) : null;
  const departure = daysUntil(trip.departureDate);
  const payment = daysUntil(trip.finalPaymentDate);
  return (
    <section className={`card trip-card${compact ? " compact" : ""}`} aria-labelledby="trip-title">
      <div className="trip-head">
        <span className="rail-title" id="trip-title">Hitos de tu viaje</span>
        {trip.destination && <strong className="trip-destination">{trip.destination}</strong>}
      </div>
      <div className="trip-rows">
        <div className="trip-row">
          <span className="benefit-icon"><PlaneTakeoff size={16} aria-hidden="true" /></span>
          <div><span>Fecha de salida</span><strong>{formatCalendarDate(trip.departureDate, "long")}</strong></div>
          {departure !== null && <em>{departure >= 0 ? `en ${departure} días` : "ya pasó"}</em>}
        </div>
        <div className="trip-row">
          <span className="benefit-icon"><CalendarCheck size={16} aria-hidden="true" /></span>
          <div><span>Pago final</span><strong>{formatCalendarDate(trip.finalPaymentDate, "long")}</strong></div>
          {payment !== null && <em>{payment >= 0 ? `en ${payment} días` : "vencido"}</em>}
        </div>
        <div className="trip-row">
          <span className="benefit-icon"><Coins size={16} aria-hidden="true" /></span>
          <div>
            <span>Aportación para asegurar tu tarifa</span>
            <strong translate="no">{contribution !== null ? money.format(contribution) : "—"}</strong>
          </div>
          {covered !== null && <em className={covered >= 1 ? "ok" : ""}>{covered >= 1 ? "cubierta" : `${Math.round(covered * 100)}% cubierta`}</em>}
        </div>
      </div>
      {covered !== null && (
        <div className="trip-progress" aria-hidden="true"><span style={{ width: `${Math.round(covered * 100)}%` }} /></div>
      )}
      {trip.notes && <p className="trip-notes">{trip.notes}</p>}
    </section>
  );
}
